import React, { useCallback, useEffect, useState } from "react";
import { registerPageList } from "../../../../commons/FixedValue";
import UserDetails from "./UserDetails";
import BankDetails from "./BankDetails";
import OfficeDetails from "./OfficeDetails";
import ConsumerDetails from "./ConsumerDetails";
import GeneratorInputForm from "./GeneratorInputForm";
// import DiscomDetails from "./DiscomDetails";
import { useDispatch, useSelector } from "react-redux";
import {
  publicCategory,
  // publicCity,
  publicControlArea,
  publicDiscom,
  publicEnergyType,
  publicGrid,
  publicHoldingCompany,
  publicNationality,
  publicPoints,
  publicRating,
  publicRegion,
  publicSpecefication,
  publicStateUT,
  publicVoltage,
} from "../../../../Redux/Slices/publicSlice";
import { fetchGenerators } from "../../../../Redux/Slices/companyAdminSlice";
import DocumentDetails from "./DocumentDetails";
import CompanyDetails from "./CompanyDetails";
import Popup from "../../../../commons/PopupModal/Popup";
import { userOnboarding } from "../../../../Services/ApiCalling/Auth";
import { addGenerator } from "../../../../Services/CompanyAdmin/AllApiAdmin";
import { decryptData } from "../../../../commons/Decode";
import { Modal } from "@mui/material";
import { Close } from "@mui/icons-material";
import { toast } from "react-toastify";
import DiscomDetails from "./DiscomDetails";
import ConfirmationModal from "../../../../commons/ConfirmationModal/ConfirmationModal";
import { set } from "date-fns";

const MainData = ({
  email = "",
  user = { case: "company_admin", value: ["COMPANY_ADMIN"] },
  viewType,
  handleViewType,
  open = false,
  handleClose = () => {},
  isCompanyAdminMode = false,
  preSelectedEntityType = null,
  isOnboardingMode = false,
}) => {
  const currUser = JSON.parse(sessionStorage.getItem("currUser"));
  const currEmail = sessionStorage.getItem("currEmail");
  const sessionUser = JSON.parse(sessionStorage.getItem("sessionUser"));
  const getDefaultViewType = () => {
    if (isCompanyAdminMode && preSelectedEntityType) {
      if (preSelectedEntityType === "consumer") {
        return "consumer_details";
      } else if (preSelectedEntityType === "generator") {
        return "generator_details";
      }
    }
    return viewType || "user_details";
  };

  const defaultViewType = getDefaultViewType();
  const dispatch = useDispatch();

  const companyInfo = useSelector(
    (state) => state?.profileSlice?.userAccess?.[0]
  );

  const [userData, setUserData] = useState(
    sessionUser || {
      email: email || currEmail,
      profile: user || currUser,
    }
  );
  console.debug("userData in MainData:", userData);

  const [openPopup, setOpenPopup] = useState(false);
  const [confirmation, setConfirmation] = useState({
    open: false,
    header: "",
    data: "",
  });
  const [currentViewType, setCurrentViewType] = useState(defaultViewType);

  const entityTypes = [
    { id: "consumer", name: "Consumer" },
    { id: "generator", name: "Generator" },
  ];

  const [selectedEntityType, setSelectedEntityType] = useState(
    preSelectedEntityType || "consumer"
  );
  const [isSelectionMode, setIsSelectionMode] = useState(false);

  useEffect(() => {
    if (preSelectedEntityType) {
      setSelectedEntityType(preSelectedEntityType);
    }
  }, [preSelectedEntityType]);

  useEffect(() => {
    if (isCompanyAdminMode && preSelectedEntityType) {
      if (preSelectedEntityType === "consumer") {
        setCurrentViewType("consumer_details");
      } else if (preSelectedEntityType === "generator") {
        setCurrentViewType("generator_details");
      }
    }
  }, [isCompanyAdminMode, preSelectedEntityType]);

  const handleEntityTypeChange = (entityId) => {
    setSelectedEntityType(entityId);
    setIsSelectionMode(false);

    if (isCompanyAdminMode) {
      if (entityId === "consumer") {
        setCurrentViewType("consumer_details");
      } else if (entityId === "generator") {
        setCurrentViewType("generator_details");
      }
    }
  };

  const handleChangeSelection = () => {
    setIsSelectionMode(true);
  };

  const localHandleViewType = handleViewType || setCurrentViewType;
  const activeViewType = handleViewType
    ? viewType || defaultViewType
    : currentViewType;

  const getDynamicPageList = () => {
    if (isCompanyAdminMode) {
      let dynamicPages = [];
      let nextId = 1;

      if (selectedEntityType) {
        if (selectedEntityType === "consumer") {
          dynamicPages.push({
            id: nextId++,
            value: "consumer_details",
            name: "Consumer Details",
          });
        } else if (selectedEntityType === "generator") {
          dynamicPages.push({
            id: nextId++,
            value: "generator_details",
            name: "Generator Details",
          });
        }
      }

      return dynamicPages;
    } else {
      return registerPageList[user?.case] || [];
    }
  };

  const handleFetchAllData = useCallback(() => {
    const actions = [
      publicRating,
      publicEnergyType,
      publicVoltage,
      publicRegion,
      publicHoldingCompany,
      publicCategory,
      publicDiscom,
      publicGrid,
      publicStateUT,
      // publicCity,
      publicPoints,
      publicNationality,
      publicSpecefication,
      publicControlArea,
    ];
    actions.forEach((action) => dispatch(action()));
  }, [dispatch]);

  useEffect(() => {
    handleFetchAllData();
  }, [handleFetchAllData]);

  const transformGeneratorPayload = (userData) => {
    const generatorData = userData?.plantDetails?.[0] || {};

    const generatorPayload = {
      generatorId: null,
      uniqueId: generatorData?.uniqueId || `GEN${Date.now()}`,
      generatorName: generatorData?.plantName || "",
      isCommissioned: generatorData?.plant === "commissioned",
      commissionedAt:
        generatorData?.plantDate || new Date().toISOString().split("T")[0],
      energyTypeId: parseInt(generatorData?.genId?.id || 0),
      specificationId: parseInt(generatorData?.specification?.id || 0),
      maxInjCap: parseFloat(generatorData?.injectionCap || 0),
      installedCap: parseFloat(generatorData?.installCap || 0),
      isSubsidyReceived: generatorData?.subsidy === "YES",
      subsidyType: generatorData?.subsidyType || "",
      isAbtExist: generatorData?.abt === "EXISTS",
      controlAreaId: parseInt(generatorData?.controlArea?.id || 0),
      pointValue: generatorData?.poi || "ISTS",
      poiLocation: generatorData?.poiLocation || "",
      stateUtId: parseInt(generatorData?.state?.id || 0),
      pan: generatorData?.pan || "",
      tan: generatorData?.tan || "",
      gst: generatorData?.gst || "",

      generatorBankDetails: {
        bankAccountId: null,
        accountHolderName: generatorData?.plantName || "",
        accountNumber: generatorData?.accountNumber || "",
        ifscCode: generatorData?.ifscCode || "",
        bankName: generatorData?.bankName || "",
        branchName: generatorData?.branchAddress || "",
      },

      istsVoltageLevel: generatorData?.istsVoltage || [],
      stuVoltageLevel: generatorData?.stuVoltage || [],

      discomDetails: generatorData?.discom || [],

      generatorDocuments: {
        aadhaarCard: "",
        panCard: generatorData?.panDocId || "",
        gstCertificate: generatorData?.gstDocId || "",
      },

      generatorOfficeAddress: {
        addressLine1: generatorData?.registered_address || "",
        addressLine2: "",
        city: generatorData?.registered_city?.name || "",
        state: generatorData?.registered_state?.name || "",
        postalCode: generatorData?.registered_pincode || "",
        country: "India",
      },

      generatorCorrespondenceAddress: {
        type: "OFFICE",
        address: generatorData?.correspondence_address || "",
        cityId: parseInt(generatorData?.correspondence_city?.id || 0),
        stateUtId: parseInt(generatorData?.correspondence_state?.id || 0),
        pinCode: parseInt(generatorData?.correspondence_pincode || 0),
        mobileNumber: generatorData?.correspondence_mobile || "",
        email: generatorData?.correspondence_email || "",
        alternateMobileNumber: generatorData?.correspondence_altMobile || "",
        contactPersonName: generatorData?.correspondence_contact || "",
      },
    };

    return [generatorPayload];
  };

  const handleGeneratorSubmit = async () => {
    try {
      const payload = transformGeneratorPayload(userData);
      const response = await addGenerator(payload);

      dispatch(fetchGenerators());

      if (handleClose) {
        handleClose();
      }
    } catch (error) {
      console.error("Error creating generator:", error);
      toast.error("Error creating generator. Please try again.");
    }
  };

  const handleProceed = async (type) => {
    const list = getDynamicPageList();
    const current = list?.find((ele) => ele?.value === activeViewType);

    if (type === "next") {
      if (isOnboardingMode) {
        if (current?.id === list?.length) {
          setConfirmation({
            open: true,
            data: "Do you want to onboard Company?",
            header: "Onboard",
          });
          return;
        }
        if (current?.id < list?.length) {
          const next = list?.find((ele) => ele?.id === current?.id + 1);
          if (next) {
            localHandleViewType(next?.value);
          }
        }
        return;
      }

      if (isCompanyAdminMode && current?.id === list?.length) {
        if (
          selectedEntityType === "generator" &&
          activeViewType === "generator_details"
        ) {
          await handleGeneratorSubmit();
          return;
        }

        return;
      }

      if (current?.id === list?.length) {
        setConfirmation({
          open: true,
          data: "Do you want to onboard Company?",
          header: "Onboard",
        });
        return;
      }
      if (current?.id < list?.length) {
        const next = list?.find((ele) => ele?.id === current?.id + 1);
        if (next) {
          localHandleViewType(next?.value);
        }
      }
    } else if (type === "prev" && current?.id > 1) {
      const prev = list?.find((ele) => ele?.id === current?.id - 1);
      if (prev) {
        localHandleViewType(prev?.value);
      }
    }
  };

  const handleData = (type, data) => {
    setUserData((prevData) => {
      // Calculate the *new* state object
      const newUserData = {
        ...prevData,
        [type]: data,
      };

      // Store the updated data in sessionStorage
      // NOTE: You must stringify non-string data like objects
      sessionStorage.setItem("sessionUser", JSON.stringify(newUserData));

      // Return the new state object to update the component's state
      return newUserData;
    });
  };

  React.useEffect(() => {
    if (selectedEntityType) {
      setUserData((prevData) => ({
        ...prevData,
        selectedEntityType: selectedEntityType,
      }));
    }
  }, [selectedEntityType]);

  const renderComponent = () => {
    const components = {
      user_details: UserDetails,
      company_details: CompanyDetails,
      bank_details: BankDetails,
      office_details: OfficeDetails,
      consumer_details: ConsumerDetails,
      generator_details: GeneratorInputForm,
      document_details: DocumentDetails,
      discom_details: DiscomDetails,
    };
    const Component = components[activeViewType];
    return (
      Component && (
        <Component
          handleData={handleData}
          handleProceed={handleProceed}
          userData={userData}
        />
      )
    );
  };

  const handleSubmit = async () => {
    let payload = {
      adminUser: {
        email: userData?.email || "NA",
        phone: userData?.userDetails?.phone || "NA",
        userName: userData?.userDetails?.userName || "NA",
        password: userData?.userDetails?.password || "NA",
        fullName: userData?.userDetails?.fullName || "NA",
        roles: userData?.profile.value || ["COMPANY_ADMIN"],
        isInterState:
          userData?.userCompany?.traderType?.label === "INTER_STATE" || false,
      },
      company: {
        holdingCompany: userData?.userCompany?.holdingCompany || null,
        companyName: userData?.userCompany?.companyName || "NA",
        displayName: userData?.userCompany?.displayName || "NA",
        description: userData?.userCompany?.companyDescription || "NA",
        logoId: 0,
        categoryId: Number(userData?.userCompany?.category?.id) || 0,
        registeredAt: userData?.userCompany?.registration
          ? new Date(userData?.userCompany?.registration)
              .toISOString()
              .split("T")[0]
          : new Date().toISOString().split("T")[0],
        pan: userData?.userCompany?.pan || "NA",
        tan: userData?.userCompany?.tan || "NA",
        gst: userData?.userCompany?.gst || "NA",
        tradingLicenseNumber: userData?.userCompany?.license || "NA",
        creditRatingId: Number(userData?.userCompany?.rating?.id) || 0,
        creditRatingYear: userData?.userCompany?.ratingYear || "NA",
        creditRatingAgency: userData?.userCompany?.agency || "NA",
        isAcceptedByLaws: userData?.userCompany?.byLaw || true,
        isAcceptedBusinessRule: userData?.userCompany?.byRules || true,
        companyOfficeAddress: {
          type: "OFFICE",
          address: userData?.address?.[0]?.address || "NA",
          cityId: Number(userData?.address?.[0]?.city?.id) || 0,
          stateUtId: Number(userData?.address?.[0]?.state?.id) || 0,
          pinCode: Number(userData?.address?.[0]?.pincode) || 0,
          mobileNumber: userData?.address?.[0]?.mobile || "NA",
          email: userData?.address?.[0]?.email || "NA",
          alternateMobileNumber: userData?.address?.[0]?.altMobile || "NA",
          contactPersonName: userData?.address?.[0]?.contact || "NA",
        },
        companyCorrespondenceAddress: {
          type: "CORRESPONDENCE",
          address: userData?.address?.[1]?.address || "NA",
          cityId: Number(userData?.address?.[1]?.city?.id) || 0,
          stateUtId: Number(userData?.address?.[1]?.state?.id) || 0,
          pinCode: Number(userData?.address?.[1]?.pincode) || 0,
          mobileNumber: userData?.address?.[1]?.mobile || "NA",
          email: userData?.address?.[1]?.email || "NA",
          alternateMobileNumber: userData?.address?.[1]?.altMobile || "NA",
          contactPersonName: userData?.address?.[1]?.contact || "NA",
        },
        companyDocuments: {
          panDocId: Number(userData?.documentList?.pan?.id) || 0,
          tanDocId: Number(userData?.documentList?.tan?.id) || 0,
          gstDocId: Number(userData?.documentList?.gst?.id) || 0,
          membershipFormDocId:
            Number(userData?.documentList?.membership?.id) || 0,
          undertakingDocId:
            Number(userData?.documentList?.membershipUndertaking?.id) || 0,
          proofOfPaymentDocId: Number(userData?.documentList?.payment?.id) || 0,
          tradingLicenseDocId: Number(userData?.documentList?.trading?.id) || 0,
          nocDocs: userData?.documentList?.noc || [],
          otherFiles: userData?.documentList?.others || [],
        },
        companyBankDetails: {
          bankName: userData?.userCompany?.bankName || "NA",
          branchAddress: userData?.userCompany?.bankAddress || "NA",
          accountNumber: userData?.userCompany?.accountNo || "NA",
          ifscCode: userData?.userCompany?.ifsc || "NA",
        },
      },
      consumers:
        userData?.consumerDetails?.length > 0
          ? userData?.consumerDetails?.map((consumer) => ({
              consumerName: consumer.plantName || "NA",
              maxCapDrawl: Number(consumer.maxDrawal) || 0,
              pointValue: consumer.poi || null,
              specificationId: Number(consumer.specification?.id) || 0,
              stateUtId: Number(consumer.state?.id) || 0,
              pan: consumer?.pan || userData?.userCompany?.pan || "NA",
              tan: consumer?.tan || userData?.userCompany?.tan || "NA",
              gst: consumer?.gst || userData?.userCompany?.gst || "NA",
              isCompanyWallet:
                consumer.bankName === userData?.userCompany?.bankName &&
                consumer.branchAddress === userData?.userCompany?.bankAddress &&
                consumer.accountNumber === userData?.userCompany?.accountNo,
              consumerBankDetails: {
                bankName:
                  consumer.bankName || userData?.userCompany?.bankName || "NA",
                branchAddress:
                  consumer.branchAddress ||
                  userData?.userCompany?.bankAddress ||
                  "NA",
                accountNumber:
                  consumer.accountNumber ||
                  userData?.userCompany?.accountNo ||
                  "NA",
                ifscCode:
                  consumer.ifscCode || userData?.userCompany?.ifsc || "NA",
              },
              istsVoltageLevel: consumer.istsVoltage?.map((v) => v.level) || [],
              stuVoltageLevel: consumer.stuVoltage?.map((v) => v.level) || [],
              discomDetails:
                consumer.discom?.map((d) => ({
                  discomId: Number(d.discomId?.discomId) || 0,
                  voltageLevel: d.voltage?.level || "NA",
                })) || [],
              consumerDocuments: {
                panDocId:
                  Number(consumer?.panDocId?.id) ||
                  Number(userData?.documentList?.pan?.id) ||
                  0,
                tanDocId:
                  Number(consumer?.tanDocId?.id) ||
                  Number(userData?.documentList?.tan?.id) ||
                  0,
                gstDocId:
                  Number(consumer?.gstDocId?.id) ||
                  Number(userData?.documentList?.gst?.id) ||
                  0,
              },
              consumerOfficeAddress: {
                type: "OFFICE",
                address:
                  consumer.registered_address ||
                  userData?.address?.[0]?.address ||
                  "NA",
                stateUtId:
                  Number(consumer.registered_state?.id) ||
                  Number(userData?.address?.[0]?.state?.id) ||
                  0,
                cityId:
                  Number(consumer.registered_city?.id) ||
                  Number(userData?.address?.[0]?.city?.id) ||
                  0,
                pinCode:
                  Number(consumer.registered_pincode) ||
                  Number(userData?.address?.[0]?.pincode) ||
                  0,
                email:
                  consumer.registered_email ||
                  userData?.address?.[0]?.email ||
                  "NA",
                contactPersonName:
                  consumer.registered_contact ||
                  userData?.address?.[0]?.contact ||
                  "NA",
                mobileNumber:
                  consumer.registered_mobile ||
                  userData?.address?.[0]?.mobile ||
                  "NA",
                alternateMobileNumber:
                  consumer.registered_altMobile ||
                  userData?.address?.[0]?.altMobile ||
                  "NA",
              },
              consumerCorrespondenceAddress: {
                type: "CORRESPONDENCE",
                address:
                  consumer.correspondence_address ||
                  userData?.address?.[1]?.address ||
                  "NA",
                stateUtId:
                  Number(consumer.correspondence_state?.id) ||
                  Number(userData?.address?.[1]?.state?.id) ||
                  0,
                cityId:
                  Number(consumer.correspondence_city?.id) ||
                  Number(userData?.address?.[1]?.city?.id) ||
                  0,
                pinCode:
                  Number(consumer.correspondence_pincode) ||
                  Number(userData?.address?.[1]?.pincode) ||
                  0,
                email:
                  consumer.correspondence_email ||
                  userData?.address?.[1]?.email ||
                  "NA",
                contactPersonName:
                  consumer.correspondence_contact ||
                  userData?.address?.[1]?.contact ||
                  "NA",
                mobileNumber:
                  consumer.correspondence_mobile ||
                  userData?.address?.[1]?.mobile ||
                  "NA",
                alternateMobileNumber:
                  consumer.correspondence_altMobile ||
                  userData?.address?.[1]?.altMobile ||
                  "NA",
              },
            }))
          : null,
      generators:
        userData?.plantDetails?.length > 0
          ? userData?.plantDetails?.map((generator) => ({
              generatorName: generator.plantName || "NA",
              isCommissioned: generator.plant === "commissioned",
              commissionedAt: generator.plantDate
                ? new Date(generator.plantDate).toISOString().split("T")[0]
                : new Date().toISOString().split("T")[0],
              energyTypeId: generator.genId?.id || 0,
              specificationId: generator.specification?.id || 0,
              maxInjCap: parseFloat(generator.injectionCap) || 0,
              installedCap: parseFloat(generator.installCap) || 0,
              isSubsidyReceived: generator.subsidy === "YES",
              subsidyType: generator.subsidyType || "NA",
              isAbtExist: generator.abt === "EXISTS",
              controlAreaId: 0,
              pointValue: generator.poi || null,
              poiLocation: generator.poiLocation || "NA",
              stateUtId: Number(generator.state?.id) || 0,
              pan: generator?.pan || userData?.userCompany?.pan || "NA",
              tan: generator?.tan || userData?.userCompany?.tan || "NA",
              gst: generator?.gst || userData?.userCompany?.gst || "NA",
              isCompanyWallet:
                generator.bankName === userData?.userCompany?.bankName &&
                generator.branchAddress ===
                  userData?.userCompany?.bankAddress &&
                generator.accountNumber === userData?.userCompany?.accountNo,
              generatorBankDetails: {
                bankName:
                  generator?.bankName ||
                  userData?.userCompany?.bankName ||
                  "NA",
                branchAddress:
                  generator?.branchAddress ||
                  userData?.userCompany?.bankAddress ||
                  "NA",
                accountNumber:
                  generator?.accountNumber ||
                  userData?.userCompany?.accountNo ||
                  "NA",
                ifscCode:
                  generator?.ifscCode || userData?.userCompany?.ifsc || "NA",
              },
              istsVoltageLevel:
                generator.istsVoltage?.map((v) => v.level) || [],
              stuVoltageLevel: generator.stuVoltage?.map((v) => v.level) || [],
              discomDetails:
                generator.discom?.map((d) => ({
                  discomId: Number(d.discomId?.discomId) || 0,
                  voltageLevel: d.voltage?.level || "NA",
                })) || [],
              generatorDocuments: {
                panDocId:
                  Number(generator?.panDocId?.id) ||
                  Number(userData?.documentList?.pan?.id) ||
                  0,
                tanDocId:
                  Number(generator?.tanDocId?.id) ||
                  Number(userData?.documentList?.tan?.id) ||
                  0,
                gstDocId:
                  Number(generator?.gstDocId?.id) ||
                  Number(userData?.documentList?.gst?.id) ||
                  0,
              },
              generatorOfficeAddress: {
                type: "OFFICE",
                address:
                  generator?.registered_address ||
                  userData?.address?.[0]?.address ||
                  "NA",
                stateUtId:
                  Number(generator?.registered_state?.id) ||
                  Number(userData?.address?.[0]?.state?.id) ||
                  0,
                cityId:
                  Number(generator?.registered_city?.id) ||
                  Number(userData?.address?.[0]?.city?.id) ||
                  0,
                pinCode:
                  Number(generator?.registered_pincode) ||
                  Number(userData?.address?.[0]?.pincode) ||
                  0,
                email:
                  generator?.registered_email ||
                  userData?.address?.[0]?.email ||
                  "NA",
                contactPersonName:
                  generator?.registered_contact ||
                  userData?.address?.[0]?.contact ||
                  "NA",
                mobileNumber:
                  generator?.registered_mobile ||
                  userData?.address?.[0]?.mobile ||
                  "NA",
                alternateMobileNumber:
                  generator?.registered_altMobile ||
                  userData?.address?.[0]?.altMobile ||
                  "NA",
              },
              generatorCorrespondenceAddress: {
                type: "CORRESPONDENCE",
                address:
                  generator?.correspondence_address ||
                  userData?.address?.[1]?.address ||
                  "NA",
                stateUtId:
                  Number(generator?.correspondence_state?.id) ||
                  Number(userData?.address?.[1]?.state?.id) ||
                  0,
                cityId:
                  Number(generator?.correspondence_city?.id) ||
                  Number(userData?.address?.[1]?.city?.id) ||
                  0,
                pinCode:
                  Number(generator?.correspondence_pincode) ||
                  Number(userData?.address?.[1]?.pincode) ||
                  0,
                email:
                  generator?.correspondence_email ||
                  userData?.address?.[1]?.email ||
                  "NA",
                contactPersonName:
                  generator?.correspondence_contact ||
                  userData?.address?.[1]?.contact ||
                  "NA",
                mobileNumber:
                  generator?.correspondence_mobile ||
                  userData?.address?.[1]?.mobile ||
                  "NA",
                alternateMobileNumber:
                  generator?.correspondence_altMobile ||
                  userData?.address?.[1]?.altMobile ||
                  "NA",
              },
            }))
          : null,
      discomId:
        Array.isArray(userData?.discomDetails) &&
        userData.discomDetails.length > 0
          ? userData.discomDetails
              .map((d) => Number(d?.discom?.discomId))
              .filter((id) => !isNaN(id) && id !== null && id !== undefined)
          : [],
    };

    try {
      let res = await userOnboarding(payload);
      console.debug("res", res);

      if (res?.data?.code === 200) {
        setOpenPopup(true);

        // Remove the 'currUser' item
        sessionStorage.removeItem("currUser");

        // Remove the 'currEmail' item
        sessionStorage.removeItem("currEmail");

        // Remove the 'sessionUser' item (from the first block of code)
        sessionStorage.removeItem("sessionUser");

        // Remove the 'currentView' item (from the second block of code)
        sessionStorage.removeItem("currentView");
        setConfirmation({
          open: false,
          header: "",
          data: "",
        });
      }
    } catch (err) {
      console.error("Submission failed", err);
    }
  };

  const modalContent = (
    <div style={{ height: "100%", width: "100%" }}>
      {renderComponent()}
      {confirmation?.open && (
        <ConfirmationModal
          open={confirmation?.open}
          data={confirmation?.data}
          header={confirmation?.header}
          handleClose={() =>
            setConfirmation({
              open: false,
              header: "",
              data: "",
            })
          }
          handleSubmit={handleSubmit}
        />
      )}
      {openPopup && (
        <Popup
          open={openPopup}
          onClose={() => {
            setOpenPopup(false);
            window.location.href = "/login";
          }}
          onConfirm={handleSubmit}
        />
      )}
    </div>
  );

  if (open) {
    return (
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="add-entity-modal"
        aria-describedby="add-entity-modal-description"
      >
        <div
          className="popupModal"
          style={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: "90%",
            maxWidth: "800px",
            maxHeight: "90%",
            backgroundColor: "white",
            borderRadius: "8px",
            padding: "0px",
            outline: "none",
            overflow: "auto",
          }}
        >
          <div
            className="display_flex_row modalHeading"
            style={{
              justifyContent: "space-between",
              alignItems: "center",
              padding: "16px 20px",
              borderBottom: "1px solid #e0e0e0",
              backgroundColor: "#f5f5f5",
            }}
          >
            <div style={{ display: "flex", alignItems: "center", gap: "20px" }}>
              <div
                className="headingText"
                style={{ fontSize: "18px", fontWeight: "600" }}
              >
                Add Entity
              </div>
              {/* Show entity type selection as tabs in company admin mode */}
              <div
                style={{ display: "flex", alignItems: "center", gap: "8px" }}
              >
                {isCompanyAdminMode ? (
                  // In company admin mode, show as tabs like in the screenshot
                  entityTypes.map((type) => (
                    <button
                      key={type.id}
                      onClick={() => handleEntityTypeChange(type.id)}
                      style={{
                        padding: "8px 16px",
                        borderRadius: "20px",
                        border: "1px solid #ddd",
                        backgroundColor:
                          selectedEntityType === type.id ? "#FF6B35" : "white",
                        color:
                          selectedEntityType === type.id ? "white" : "#333",
                        fontSize: "14px",
                        cursor: "pointer",
                        fontWeight:
                          selectedEntityType === type.id ? "600" : "400",
                        transition: "all 0.2s ease",
                      }}
                    >
                      {type.name}
                    </button>
                  ))
                ) : (
                  // Regular mode behavior
                  <>
                    {isSelectionMode || !selectedEntityType ? (
                      // Show all options with Consumer highlighted by default
                      entityTypes.map((type) => (
                        <button
                          key={type.id}
                          onClick={() => handleEntityTypeChange(type.id)}
                          style={{
                            padding: "8px 16px",
                            borderRadius: "20px",
                            border:
                              type.id === "consumer"
                                ? "2px solid #1976d2"
                                : "1px solid #ddd",
                            backgroundColor:
                              type.id === "consumer" ? "#e3f2fd" : "white",
                            color: type.id === "consumer" ? "#1976d2" : "#333",
                            fontSize: "14px",
                            cursor: "pointer",
                            fontWeight: type.id === "consumer" ? "600" : "400",
                            transition: "all 0.2s ease",
                          }}
                        >
                          {type.name}
                        </button>
                      ))
                    ) : (
                      // Show selected option with change button
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: "8px",
                        }}
                      >
                        <button
                          style={{
                            padding: "8px 16px",
                            borderRadius: "20px",
                            border: "2px solid #1976d2",
                            backgroundColor: "#1976d2",
                            color: "white",
                            fontSize: "14px",
                            fontWeight: "600",
                            cursor: "default",
                          }}
                        >
                          {
                            entityTypes.find(
                              (et) => et.id === selectedEntityType
                            )?.name
                          }
                        </button>
                        <button
                          onClick={handleChangeSelection}
                          style={{
                            padding: "6px 12px",
                            borderRadius: "15px",
                            border: "1px solid #999",
                            backgroundColor: "white",
                            color: "#666",
                            fontSize: "12px",
                            cursor: "pointer",
                            transition: "all 0.2s ease",
                          }}
                        >
                          Change
                        </button>
                      </div>
                    )}
                  </>
                )}
              </div>
            </div>
            <Close
              style={{ fontSize: 24, color: "#777777", cursor: "pointer" }}
              onClick={handleClose}
            />
          </div>
          <div style={{ padding: "20px" }}>{modalContent}</div>
        </div>
      </Modal>
    );
  }

  return modalContent;
};

export default MainData;
